module.exports = __webpack_public_path__ + "static/media/twitter-logo.30836591.svg";